import Glide from "@glidejs/glide";

import './style.css';

// eslint-disable-next-line import/named
import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store( 'parslows/key-topical-issues', {
	state: {
		currentSlide: 1,
		totalSlides: 0,
		instance: null,
		isOpen: false,

		slideCounts() {
			const { totalSlides } = state;
			
			return Array.from( { length: totalSlides }, ( _, i ) => ( {
				index: i,
				isActive: i === state.currentSlide - 1
			} ) );
		},
	},

	effects: {
		onSliderInit: (props) => {
			const { ref } = getElement();

			const settingsScript = ref.querySelector( ':scope > script[data-quanta-slider]' );

			let options = {};

			try {
				options = JSON.parse( settingsScript.textContent );
			} catch( ex ) {
				// Do nothing
			}

			const slider = new Glide( ref, options ).mount( {
				Length: ( Glide, Components, Events ) => {
					return {
						mount() {
							state.totalSlides = 1 + ( Components.Sizes.length - Glide.settings.perView );
						}
					};
				}
			} );

			state.instance = slider;

			slider.on( 'move', () => {
				state.currentSlide = slider.index + 1;
				// state.total = slider.
				console.log('this shows after slide move');
			})

			console.log({ ref, slider })
		}
	}
} );
